import { Component, HostBinding, OnInit, OnDestroy, HostListener, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Router, ActivatedRoute, Params, NavigationEnd, RouterEvent } from '@angular/router';
import { Wiki } from './wiki.model';
import { WikiService } from './wiki.service';
import { NavigationService } from '../shared/navigation/navigation.service';
import { Page } from '../shared/navigation/pages.model';
import { Subscription, take } from 'rxjs';
import { environment } from '../../environments/environment';
import { utils } from '../shared/helpers/utils';
import { AuthService, UserState } from '../shared/auth/auth.service';

@Component({
  selector: 'app-wiki',
  templateUrl: 'wiki.component.html',
  styleUrls: ['wiki.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class WikiComponent implements OnInit, OnDestroy {
 public cdn = environment.cdn;
 public base:any;
 public path_list = '/';
 public path_details = '/';
 public pageTitle: string;
 public wikis: Wiki[];
 public children: Page[] = [];
 public currentUrl = '';
 public count = 0;
 public pageSize = 12;
 public page = 0;
 public query: any = {page: 1, pagesize: 99};
 public sub: Subscription = null;
 public sub1: Subscription = null;
 public sub2: Subscription = null;
 public categories: Page[] = [];
 public selected: number;
 public links = ['First', 'Second', 'Third'];
 public initial = false;
 public allowed = [1];

 constructor(private router: Router, private route: ActivatedRoute, private navigationService: NavigationService, private auth: AuthService,
             private wikiService: WikiService, private cdr: ChangeDetectorRef) {
    this.path_details = this.router.config.find(r => r.data?.module === 'WikiDetailsModule')?.data.path || '/';  
    this.base = this.router.config.filter(r => r?.data?.module === 'WikiModule').reduce((prev, curr) => (prev.data.level < curr.data.level) ? prev : curr);
    this.path_list = this.base?.path || '/';
    
 }

 deactivate($event) {
  console.log('deactivate');
 }

 ngOnInit() {

  this.currentUrl = this.router.url;
  this.selected = this.route.snapshot.data['id'];
  if (this.selected) {
    this.query['category'] = this.selected;
  }
  this.pageTitle = this.base.data.name;

  this.sub = this.navigationService.navigation.subscribe((menu: any) => {
    this.categories = this.findId(+this.base.data.id, menu.invisible)?.children || [];

    if (+this.base.data.id != +this.selected) {
      this.initial = false;
      this.sub1 = this.route.queryParamMap.subscribe(params => {
        this.query['page'] = params.get('page') || 1;
        this.query['pagesize'] = params.get('pagesize') || 12;
        this.getWikis();
      });
    } else {
      this.initial = true;
    }
  });

  this.auth.isLoggedIn.subscribe((state: UserState) => {

    if (state.logged) {
      this.allowed = [1,2];
    } else {
      this.allowed = [1];
    }
  });

 }

 findId(id: number, list: any) {
  for (const _item of list) {
    if (+_item.id === +id) {
      return _item;
    } else if (_item?.children && _item.children.length) { 
      const subId = this.findId(id, _item.children);
      if (+subId.id === +id) {
        return subId;
      }
    }
  }
  // Return undefined if not found
  return 0;
}

 trackWikiBy(index, wiki) {
   return index;
 }

 onPage(event: any) {
  this.query['page'] = event.pageIndex + 1;
  this.router.navigate([this.path_list], { queryParams: this.query });
}

getWikis() {
  this.wikiService.items(this.query).pipe(take(1)).subscribe(wikis => {
    this.wikis = wikis.items || [];
    this.count = wikis.pages.totalItemCount || 0;
    this.cdr.markForCheck();
  });
}

 ngOnDestroy() {
   if (this.sub) {
     this.sub.unsubscribe();
   }
   if (this.sub1) {
     this.sub1.unsubscribe();
   }
   if (this.sub2) {
     this.sub2.unsubscribe();
   }
 }

}
